import { render, staticRenderFns } from "./GroupMembersCard.vue?vue&type=template&id=383fe5e7&scoped=true&"
import script from "./GroupMembersCard.vue?vue&type=script&lang=js&"
export * from "./GroupMembersCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupMembersCard.vue?vue&type=style&index=0&id=383fe5e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383fe5e7",
  null
  
)

export default component.exports